// extracted by css-extract-rspack-plugin
export default {"groupDescription":"suZvk"};